import { GetCountriesSuccessAction } from "../actions/CacheGetCountries/CacheGetCountriesActionTypes";
import { CacheReducerState } from "../models/definitions";
import { initialState } from "./CacheInitialState";

export const handleGetCountriesSuccess = (
  state = initialState,
  { payload }: GetCountriesSuccessAction
): CacheReducerState => ({
  ...state,
  countries: payload.countries
});

export const handleGetCountriesFailure = (
  state = initialState
): CacheReducerState => ({
  ...state,
  countries: []
});
